import { Deserializable } from '../../lib/models/deserializable';
import { EntityResponseDto } from '../../lib/models/dto/entity-response-dto.model';
import { ValidationErrors } from '../../lib/models/validation/validation-errors';
import { ProductDto } from './product-dto.model';

export class ProductPickerResponse implements Deserializable {
  public Entities: Array<EntityResponseDto<ProductDto>>;
  public ValidationErrors: ValidationErrors;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.ValidationErrors = new ValidationErrors(input.ValidationErrors);
    this.Entities = input.Entities.map((productEntityDto) => {
      const product = new EntityResponseDto<ProductDto>().deserialize(productEntityDto);
      product.Entity = new ProductDto().deserialize(productEntityDto.Entity);

      return product;
    });

    return this;
  }
}
